
// https://youmightnotneedjquery.com

export default class DOMHelpers {
    constructor(root = document) {
        this.root = root;
    }

    qs(sel, ctx = this.root) {
        return ctx.querySelector(sel);
    }

    qsa(sel, ctx = this.root) {
        return Array.from(ctx.querySelectorAll(sel));
    }

    on(el, evt, fn, opts) {
        if (!el) return;
        if (NodeList.prototype.isPrototypeOf(el) || Array.isArray(el)) el.forEach(i => i.addEventListener(evt, fn, opts));
        else el.addEventListener(evt, fn, opts);
    }

    off(el, evt, fn, opts) {
        if (!el) return;
        if (NodeList.prototype.isPrototypeOf(el) || Array.isArray(el)) el.forEach(i => i.removeEventListener(evt, fn, opts));
        else el.removeEventListener(evt, fn, opts);
    }

    addClass(el, cls) {
        if (!el) return;
        el.classList.add(...String(cls).split(/\s+/));
    }

    removeClass(el, cls) {
        if (!el) return;
        el.classList.remove(...String(cls).split(/\s+/));
    }

    toggleClass(el, cls) {
        if (!el) return;
        el.classList.toggle(...String(cls).split(/\s+/));
    }

    hasClass(el, cls) {
        return el ? el.classList.contains(cls) : false;
    }

    htmlToDoc(html) {
        return new DOMParser().parseFromString(html, 'text/html');
    }

    offset(el) {
        let box = el.getBoundingClientRect(),
            docElem = document.documentElement;
        return {
            top: box.top + window.pageYOffset - docElem.clientTop,
            left: box.left + window.pageXOffset - docElem.clientLeft
        };

    }
    parents(el, selector) {
        const parents = [];
        while ((el = el.parentNode) && el !== document) {
            if (!selector || el.matches(selector)) parents.push(el);
        }
        return parents;
    }
    
    generateElements(html) {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.children;
    }

    getClassesContainingString(domTokenList, searchString) {
        const matchingClasses = [];
        for (let i = 0; i < domTokenList.length; i++) {
            const className = domTokenList.item(i);
            if (className.includes(searchString)) {
                matchingClasses.push(className);
            }
        }
        return matchingClasses.length > 0 ? matchingClasses : false;
    }

    trigger(el, eventType){
        if (typeof eventType === 'string' && typeof el[eventType] === 'function') {
            el[eventType]();
        } else {
            const event =
            typeof eventType === 'string'
                ? new Event(eventType, {bubbles: true})
                : eventType;
            el.dispatchEvent(event);
        }
    }


    // small helper to convert jQuery-like object or selector to Element(s)
    elm(selOrEl, ctx = this.root) {
        if (!selOrEl) return null;
        if (typeof selOrEl === 'string') return this.qs(selOrEl, ctx);
        if (selOrEl instanceof Element) return selOrEl;
        // NodeList or array
        if (NodeList.prototype.isPrototypeOf(selOrEl) || Array.isArray(selOrEl)) return Array.from(selOrEl);
        return selOrEl;
    }
}